import(/* webpackMode: "eager" */ "/app/src/app/(tenant)/tenant/[subdomain]/not-found.tsx");
